<div class="mat-dialog">
  <div class="modal-header" tabindex="0">
    <h3 mat-dialog-title>{{ data.title }}</h3>
    <img
      src="assets/close.svg"
      alt="close-modal"
      (click)="onCancel()"
      (keydown)="onCancel($event)"
      tabindex="0"
      title="Close"
    />
  </div>
  <div mat-dialog-content class="modal-dialog-content">
    <div class="question">
      <div class="content">
        <form
          [formGroup]="changePasswordForm"
          (ngSubmit)="onSubmit()"
          novalidate
          aria-label="Change Password Form"
        >
          <div class="row">
            <div class="col-12 col-sm-6">
              <app-common-input
                type="password"
                formControlName="newPassword"
                label="New Password"
                placeholder="Enter New Password"
                id="newPassword"
                inputType="password"
                [isRequired]="true"
                [isSubmit]="isSubmit"
              >
              </app-common-input>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-6">
              <app-common-input
                type="password"
                formControlName="confirmPassword"
                label="Confirm Password"
                placeholder="Enter Confirm Password"
                id="confirmPassword"
                inputType="password"
                [isRequired]="true"
                [isSubmit]="isSubmit"
              >
              </app-common-input>
            </div>
          </div>
          <div>
            @if (
              isSubmit &&
              this.changePasswordForm.value.newPassword !==
                this.changePasswordForm.value.confirmPassword
            ) {
              <p
                class="mb-3 m-0 error-message"
                aria-label="Confirm Password and New Password should be same"
              >
                Confirm Password and New Password should be same
              </p>
            }
          </div>
          <section class="password-validation-container">
            <h4>Password Must be:</h4>
            <ul class="ps-0 mt-4">
              <li
                *ngFor="let error of passwordErrors; let i = index"
                class="d-flex align-items-center"
              >
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  [ngClass]="{
                    'text-success': error === 'success',
                    'text-danger': error === 'failed',
                    'text-normal': error === 'normal',
                  }"
                >
                  <rect
                    y="0.5"
                    width="16"
                    height="16"
                    rx="8"
                    [attr.fill]="
                      error === 'normal'
                        ? '#9CA3AF'
                        : error === 'success'
                          ? '#2D9F5D'
                          : '#DC2626'
                    "
                  />
                  <path
                    *ngIf="error === 'success'"
                    d="M11.7334 5.70007L6.60006 10.8334L4.26672 8.50007"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    *ngIf="error === 'failed'"
                    d="M4.5 12L11.5 5M11.5 12L4.5 5"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  <!-- checkmark path for 'normal' state -->
                  <path
                    *ngIf="error === 'normal'"
                    d="M4.5 8.5L6.66667 10.6667L11.5 5.83333"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <!-- over -->
                </svg>
                <p class="m-0 ms-2">{{ getPasswordErrorMessage(i) }}</p>
              </li>
            </ul>
          </section>
        </form>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions class="modal-footer">
  <app-button variant="secondary" mat-button (click)="onCancel()"
    >Cancel</app-button
  >
  <app-button
    variant="primary"
    (click)="onSubmit()"
    [isDisabled]="!changePasswordForm.valid || !isPasswordValid()"
  >
    Change Password</app-button
  >
</div>
